import { Box } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import LanguageIcon from '@material-ui/icons/Language';
import MoreIcon from '@material-ui/icons/MoreVert';
import ProfilePictureMenu from 'components/header/app/ProfilePictureMenu';
import useStyles from 'components/header/app/styles/HeaderStyles';
import { RoutesPaths } from 'constants/routesPath';
import appRoutes from 'layouts/app/routes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink, useLocation } from 'react-router-dom';
import authManager from 'services/authManager';
import DIRECTION from '../../../constants/direction';
import useLocale from '../../../hooks/localization/useLocale';
import Notifications from '../admin/notifications';
import AppMenu from './AppMenu';

export default function MainHeader() {
  const menuList = appRoutes.filter((route) => !!route.hasDashboardLink);
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation();
  const { locale, toggleLocale } = useLocale();
  const location = useLocation();
  const authToken = authManager.retrieveUserToken();
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuId = 'primary-search-account-menu';
  const showHeaderNav =
    location.pathname === RoutesPaths.App.LandingPage ||
    location.pathname === RoutesPaths.App.ContactUs ||
    location.pathname === RoutesPaths.App.Solutions ||
    location.pathname === RoutesPaths.App.About ||
    location.pathname === RoutesPaths.App.Consultants ||
    location.pathname === RoutesPaths.App.TermsAndConditions;
  return (
    <div className={classes.grow} dir={DIRECTION[locale]}>
      <AppBar
        className={classes.headerBackground}
        id={'header'}
        position='fixed'>
        <Toolbar>
          <AppMenu menuList={menuList} />
          <Box className={classes.mobileLogoContainer}>
            <Link
              to={RoutesPaths.App.LandingPage}
              className={classes.logoImage}>
              <img
                src={require('../../../assets/desktop_nformacy_logo.svg')}
                width={140}
                className={classes.desktopVisible}
              />
              <img
                src={require('../../../assets/mobile_nformacy_logo.svg')}
                className={classes.mobileVisible}
              />
            </Link>
          </Box>

          {showHeaderNav && (
            <Box className={classes.sectionDesktop}>
              <NavLink
                exact
                to={RoutesPaths.App.LandingPage}
                className={classes.menuItemText}
                activeClassName={classes.active}>
                {t('home')}
              </NavLink>
              <NavLink
                to={RoutesPaths.App.About}
                className={classes.menuItemText}
                activeClassName={classes.active}>
                {t('about')}
              </NavLink>
              <NavLink
                to={RoutesPaths.App.ContactUs}
                className={classes.menuItemText}
                activeClassName={classes.active}>
                {t('connect')}
              </NavLink>
            </Box>
          )}

          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <Button
              id={'switchLang'}
              color={'primary'}
              className={classes.languageButton}
              onClick={toggleLocale}>
              {t('language')}
            </Button>
          </div>
          {authToken && (
            <div className={classes.sectionMobile}>
              <IconButton
                aria-label='show 17 new notifications'
                className={classes.notificationMobile}
                color='inherit'>
                <Notifications />
              </IconButton>
              <IconButton
                aria-label='show more'
                aria-controls={menuId}
                aria-haspopup='true'
                onClick={handleProfileMenuOpen}
                color='inherit'>
                <MoreIcon />
              </IconButton>
              <LanguageIcon
                className={classes.languageIcon}
                onClick={toggleLocale}
              />
            </div>
          )}
        </Toolbar>
      </AppBar>
      <ProfilePictureMenu
        anchorEl={anchorEl}
        handleClose={handleClose}
        menuId={menuId}
      />
    </div>
  );
}
